import {
  patternSessionReducer,
  type PatternAction,
  type PatternRepository,
  type PatternSession,
} from '@miyuki/domain';
import * as React from 'react';

/** Espera antes de autoguardar el borrador, para no escribir en cada toque. */
const DRAFT_DEBOUNCE_MS = 600;

/**
 * Envuelve el reductor de sesión del dominio y se encarga del borrador.
 *
 * Toda la lógica de edición y de historial vive en `@miyuki/domain`: aquí solo
 * queda conectarla a React y persistir el trabajo en curso para que cerrar la
 * pestaña no cueste el diseño (RF-41).
 */
export function usePatternSession(
  repository: PatternRepository,
  initialSession: PatternSession,
): readonly [PatternSession, React.Dispatch<PatternAction>] {
  const [session, dispatch] = React.useReducer(patternSessionReducer, initialSession);

  React.useEffect(() => {
    if (!session.dirty) return undefined;

    const timer = setTimeout(() => {
      void repository.saveDraft(session.pattern, session.savedFrom);
    }, DRAFT_DEBOUNCE_MS);

    return () => {
      clearTimeout(timer);
    };
  }, [repository, session.dirty, session.pattern, session.savedFrom]);

  return [session, dispatch] as const;
}
